export default "__VITE_ASSET__CbU8YgyT__"